import { Pagination, PaginationRenderItemParams } from "@mui/material";
import PaginationItem from '@mui/material/PaginationItem';
import { UseTableReturn } from "../table";

type OwnProps = {
    table: UseTableReturn,
    count: number;
}

const CustomTablePagination = ({ table, count }: OwnProps) => {
    return (
        <Pagination
            color="primary"
            variant="soft"
            page={table.page + 1}
            shape="rounded"
            count={Math.ceil(count / table.rowsPerPage)}
            onChange={(event, page) => {
                table.onChangePage(event, page - 1);
            }}
            sx={{
                mt: 2,
                mb: 2,
                '& > .MuiPagination-ul': {
                    justifyContent: 'center',
                },
            }}
            renderItem={(item: PaginationRenderItemParams) => (
              <PaginationItem
                  page={item.page}
                  type={item.type}
                  selected={item.selected}
                  disabled={item.disabled}
                  onClick={item.onClick}
                  data-test-id={
                      item.type === 'page'
                          ? `page-${item.page}`
                          : `button-${item.type}`
                  }
              />
          )}
        />
    )
}

export default CustomTablePagination;